import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  Eye as ViewIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Trash as DeleteIcon,
  Wand2 as GenerateIcon
} from 'lucide-react';

interface InteractionControlsProps {
  onView?: () => void;
  onEdit?: () => void;
  onSave?: () => void;
  onDelete?: () => void;
  onGenerate?: () => void;
  isEditing?: boolean;
  showView?: boolean;
}

const InteractionControls: React.FC<InteractionControlsProps> = ({
  onView,
  onEdit,
  onSave,
  onDelete,
  onGenerate,
  isEditing,
  showView = true
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {showView && (
        <Tooltip title="View">
          <IconButton onClick={onView} size="small" sx={{ color: '#00FFFF' }}>
            <ViewIcon size={18} />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={isEditing ? "Save" : "Edit"}>
        <IconButton 
          onClick={isEditing ? onSave : onEdit} 
          size="small"
          sx={{ color: isEditing ? '#00CC99' : '#8A2BE2' }}
        >
          {isEditing ? <SaveIcon size={18} /> : <EditIcon size={18} />}
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton onClick={onDelete} size="small" sx={{ color: '#FF6F00' }}>
          <DeleteIcon size={18} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Generate with AI">
        <IconButton onClick={onGenerate} size="small" sx={{ color: '#00CC99' }}>
          <GenerateIcon size={18} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default InteractionControls; 